import { render, staticRenderFns } from "./OldUnionMenu.vue?vue&type=template&id=6f2d438b&scoped=true&"
import script from "./OldUnionMenu.vue?vue&type=script&lang=js&"
export * from "./OldUnionMenu.vue?vue&type=script&lang=js&"
import style0 from "./OldUnionMenu.vue?vue&type=style&index=0&id=6f2d438b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d438b",
  null
  
)

export default component.exports